import { ExternalChatChannel, isExternalChatChannel } from "domain-entities";
import { CollectionPath } from "Configs/firebase";
import { useCollectionStore, FirestoreWhere } from "Helpers/StoreHelper";
import { firestore } from "firebase/app";
import { useRef } from "react";
import { useViewer } from "Components/Auth/AuthProvider";

export function useChannelsStore(organizationId: string) {
  const viewer = useViewer();
  const collectionRef = useRef(
    firestore()
      .collection(CollectionPath.ORGANIZATIONS)
      .doc(organizationId)
      .collection(CollectionPath.CHANNELS)
  );

  const sortRef = useRef((a: ExternalChatChannel, b: ExternalChatChannel) =>
    a.name.localeCompare(b.name)
  );

  const whereRef = useRef<FirestoreWhere[]>([
    ["access", "array-contains", viewer.user.uid],
  ]);

  return useCollectionStore<ExternalChatChannel>({
    collection: collectionRef.current,
    where: whereRef.current,
    is: isExternalChatChannel,
    sort: sortRef.current,
  });
}
